module.exports = __webpack_public_path__ + "img/icon-activity.74983bbc.svg";